// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FaArrowLeft, FaMoneyBillWave, FaSignOutAlt } from 'react-icons/fa';
// import './Prapt_Aai.css'; 
// import topLogo from './logo-placeholder.png'; 

// const Prapt_Aai = () => {
//     const navigate = useNavigate();

//     // --- 1. FORM STATE (New) ---
//     const [formData, setFormData] = useState({
//         receiptNo: '',
//         date: '',
//         name: '',
//         descSelect: '',
//         descText: '',
//         paymentMode: '', 
//         amount: ''
//     });

//     // --- 2. BACK BUTTON & EXIT LOGIC (Kept from your previous code) ---
//     const [showExitModal, setShowExitModal] = useState(false);

    
//     // --- 3. BUTTON ACTIONS (Logout) ---
//     const handleYesLogout = () => {
//         localStorage.removeItem('user');
//         localStorage.removeItem('token'); 
//         localStorage.removeItem('isLoggedIn');
//         navigate('/'); 
//     };

//     const handleNoStay = () => setShowExitModal(false);
//     const handleManualLogout = () => setShowExitModal(true);

//     // --- 4. FORM HANDLERS (New) ---
//  const handleChange = (e) => {
//         const { name, value } = e.target;

//         // Apply "Numbers Only" rule to BOTH Receipt No AND Amount
//         if (name === 'receiptNo' || name === 'amount') {
            
//             // Regex to allow only digits (0-9)
//             if (value === '' || /^[0-9\b]+$/.test(value)) {
//                 setFormData({ ...formData, [name]: value });
//             }
//         } 
//         // For all other fields (Name, Text, etc.), allow anything
//         else {
//             setFormData({ ...formData, [name]: value });
//         }
//     };

// // --- UPDATED SUBMIT HANDLER ---
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         // 1. Basic Validation
//         if (!formData.receiptNo || !formData.date || !formData.amount || !formData.name) {
//             alert("Please fill all required fields");
//             return;
//         }

//         // --- FIX: GET LOGGED-IN USERNAME CORRECTLY ---
//         let currentUsername = 'Guest'; // Default if no one is logged in

//         // A. Get the 'user' data string from storage
//         const storedUser = localStorage.getItem('user');
        
//         // B. If it exists, parse it and find the name
//         if (storedUser) {
//             try {
//                 const parsedUser = JSON.parse(storedUser);
//                 // Check if your login saves it as 'name', 'username', or just the string
//                 currentUsername = parsedUser.name || parsedUser.username || parsedUser.email || 'Admin';
//             } catch (error) {
//                 // If it's just a plain string (not JSON), use it directly
//                 currentUsername = storedUser;
//             }
//         }
//         // ---------------------------------------------

//         try {
//             // 3. Send Data to Backend
//             const response = await fetch('/api/dashboard/add-income', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     receiptNo: formData.receiptNo,
//                     date: formData.date,
//                     name: formData.name,
//                     descSelect: formData.descSelect,
//                     descText: formData.descText,
//                     amount: formData.amount,
//                     paymentMode: formData.paymentMode,
//                     username: currentUsername // <--- Sending the correct name
//                 }),
//             });

//             const result = await response.json();

//             if (result.success) {
//                 alert("✅ Data Saved Successfully!");
//                 // Clear form...
//                 setFormData({ receiptNo: '', date: '', name: '', descSelect: '', descText: '', amount: '' });
//             } else {
//                 alert("❌ Error: " + result.message);
//             }

//         } catch (error) {
//             console.error("Submission Error:", error);
//             alert("❌ Server Connection Error");
//         }
//     };

//     return (
//       <div className="details-container">
//         {/* --- SIGNOUT BUTTON --- */}
//         <button className="logout-btn" onClick={handleManualLogout}>
//           <FaSignOutAlt />
//           <span>Sign Out</span>
//         </button>

//         {/* --- POPUP MODAL --- */}
//         {showExitModal && (
//           <div className="modal-overlay">
//             <div className="modal-box">
//               <h3>Warning</h3>
//               <p>Do you want to Sign Out?</p>
//               <div className="modal-actions">
//                 <button className="btn-confirm" onClick={handleYesLogout}>
//                   Yes
//                 </button>
//                 <button className="btn-cancel" onClick={handleNoStay}>
//                   No
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* --- BACKGROUND SHAPES (Kept unchanged) --- */}
//         <div className="shape shape-1"></div>
//         <div className="shape shape-2"></div>
//         <div className="shape shape-3"></div>

//         {/* --- TOP BRAND HEADER (Kept unchanged) --- */}
//         <div className="brand-header">
//           <img src={topLogo} alt="Logo" className="brand-logo" />
//           <div className="brand-text">
//             <h2>गायत्री परिवार</h2>
//             <h3>अलीराजपुर</h3>
//           </div>
//         </div>

//         {/* --- PAGE HEADER (Kept unchanged) --- */}
//         <div className="details-header">
//           <button className="back-btn" onClick={() => navigate("/home")}>
//             <FaArrowLeft /> Back
//           </button>
//           <h2>
//             <FaMoneyBillWave /> प्राप्त आय
//           </h2>
//         </div>

//         {/* --- NEW FORM SECTION (Replaces the Table Wrapper) --- */}
//         <div className="form-content-wrapper">
//           <div className="prapt-form-card">
//             <form onSubmit={handleSubmit}>
//               {/* 0. PAYMENT MODE */}
//               <div className="prapt-form-group">
//                 <select
//                   name="paymentMode"
//                   value={formData.paymentMode}
//                   onChange={handleChange}
//                   className="prapt-input"
//                 >
//                   <option value="">भुगतान का प्रकार (Mode)</option>
//                   <option value="OFFLINE">OFFLINE</option>
//                   <option value="ONLINE">ONLINE</option>
//                 </select>
//               </div>

//               {/* 1. Receipt No */}
//               <div className="prapt-form-group">
//                 <input
//                   type="text"
//                   inputMode="numeric"
//                   name="receiptNo"
//                   placeholder="रसीद क्रमांक"
//                   value={formData.receiptNo}
//                   onChange={handleChange}
//                   className="prapt-input"
//                 />
//               </div>

//               {/* 2. Date (Attractive Version) */}
//               <div className="prapt-form-group">
//                 <input
//                   type="text" /* Starts as text to show placeholder */
//                   name="date"
//                   placeholder="दिनांक" /* The attractive placeholder */
//                   value={formData.date}
//                   onChange={handleChange}
//                   onFocus={(e) =>
//                     (e.target.type = "date")
//                   } /* Becomes date on click */
//                   onBlur={(e) =>
//                     (e.target.type = e.target.value ? "date" : "text")
//                   } /* Reverts if empty */
//                   className="prapt-input date-style"
//                 />
//               </div>

//               {/* 3. Name */}
//               <div className="prapt-form-group">
//                 <input
//                   type="text"
//                   name="name"
//                   placeholder="दानदाता का नाम"
//                   value={formData.name}
//                   onChange={handleChange}
//                   className="prapt-input"
//                 />
//               </div>

//               {/* 4. Description Dropdown */}
//               {/* 4. Description Dropdown (Updated with full list) */}
//               <div className="prapt-form-group">
//                 <select
//                   name="descSelect"
//                   value={formData.descSelect}
//                   onChange={handleChange}
//                   className="prapt-input"
//                 >
//                   {/* Default Placeholder */}
//                   <option value="">विवरण का चयन करे</option>

//                   {/* --- Items from your Images --- */}

//                   <option value="गायत्री यज्ञ">गायत्री यज्ञ</option>
//                   <option value="यज्ञ कुण्ड">यज्ञ कुण्ड</option>
//                   <option value="अंशदान">अंशदान</option>
//                   <option value="आओ गढे संस्कार वान पीढ़ी">
//                     आओ गढे संस्कार वान पीढ़ी
//                   </option>
//                   <option value="दीक्षा एवं यज्ञोपवीत संस्कार">
//                     दीक्षा एवं यज्ञोपवीत संस्कार
//                   </option>
//                   <option value="अन्य संस्कार से प्राप्त आय">
//                     अन्य संस्कार से प्राप्त आय
//                   </option>
//                   <option value="नवरात्री पर्व">नवरात्री पर्व</option>
//                   <option value="दान पेटी से प्राप्त आय">
//                     दान पेटी से प्राप्त आय
//                   </option>
//                   <option value="वस्तु दान की बिक्री से आय">
//                     वस्तु दान की बिक्री से आय
//                   </option>

//                   <option value="गौशाला हेतु दान">गौशाला हेतु दान</option>
//                   <option value="साहित्य से बिक्री">साहित्य से बिक्री</option>

//                   <option value="बैंक ब्याज से प्राप्त आय">
//                     बैंक ब्याज से प्राप्त आय
//                   </option>
//                   <option value="अन्य स्रोत से आय">अन्य स्रोत से आय</option>
//                 </select>
//               </div>

//               {/* 5. Description Text */}
//               <div className="prapt-form-group">
//                 <input
//                   type="text"
//                   name="descText"
//                   placeholder="विवरण लिखे"
//                   value={formData.descText}
//                   onChange={handleChange}
//                   className="prapt-input"
//                 />
//               </div>

//               {/* 6. Amount */}
//               <div className="prapt-form-group">
//                 <input
//                   type="number"
//                   name="amount"
//                   placeholder="जमा राशि"
//                   value={formData.amount}
//                   onChange={handleChange}
//                   className="prapt-input"
//                 />
//               </div>

//               {/* SUBMIT BUTTON */}
//               <button type="submit" className="prapt-submit-btn">
//                 ! ! जमा करे ! !
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     );
// };

// export default Prapt_Aai;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaMoneyBillWave, FaSignOutAlt } from 'react-icons/fa';
import './Prapt_Aai.css'; 
import topLogo from './logo-placeholder.png'; 

const Prapt_Aai = () => {
    const navigate = useNavigate();

    // --- 1. FORM STATE ---
    const [formData, setFormData] = useState({
        receiptNo: '',
        date: '',
        name: '',
        descSelect: '',
        descText: '',
        paymentMode: '', 
        amount: ''
    });

    const [showExitModal, setShowExitModal] = useState(false);
    
    // --- 2. PROGRESS BAR STATE (New) ---
    const [isLoading, setIsLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    // --- 3. BUTTON ACTIONS (Logout) ---
    const handleYesLogout = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('token'); 
        localStorage.removeItem('isLoggedIn');
        navigate('/'); 
    };

    const handleNoStay = () => setShowExitModal(false);
    const handleManualLogout = () => setShowExitModal(true);

    // --- 4. FORM HANDLERS ---
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Apply "Numbers Only" rule to BOTH Receipt No AND Amount
        if (name === 'receiptNo' || name === 'amount') {
            if (value === '' || /^[0-9\b]+$/.test(value)) {
                setFormData({ ...formData, [name]: value });
            }
        } 
        // For all other fields (Name, Text, etc.), allow anything
        else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // --- UPDATED SUBMIT HANDLER WITH PROGRESS BAR ---
    const handleSubmit = async (e) => {
        e.preventDefault();

        // 1. Basic Validation
        if (!formData.receiptNo || !formData.date || !formData.amount || !formData.name) {
            alert("Please fill all required fields");
            return;
        }

        // --- START PROGRESS BAR LOGIC ---
        setIsLoading(true);
        setProgress(10); // Start at 10%

        const progressInterval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 90) return 90; // Stall at 90% until server responds
                return prev + 10;
            });
        }, 200);

        // --- GET LOGGED-IN USERNAME ---
        let currentUsername = 'Guest'; 
        const storedUser = localStorage.getItem('user');
        
        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                currentUsername = parsedUser.name || parsedUser.username || parsedUser.email || 'Admin';
            } catch (error) {
                currentUsername = storedUser;
            }
        }

        try {
            // Send Data to Backend
            const response = await fetch('/api/dashboard/add-income', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    receiptNo: formData.receiptNo,
                    date: formData.date,
                    name: formData.name,
                    descSelect: formData.descSelect,
                    descText: formData.descText,
                    amount: formData.amount,
                    paymentMode: formData.paymentMode,
                    username: currentUsername 
                }),
            });

            const result = await response.json();

            // --- STOP PROGRESS BAR ---
            clearInterval(progressInterval);

            if (result.success) {
                setProgress(100); // Complete the bar
                
                // Small delay so user sees 100% before it disappears
                setTimeout(() => {
                    setIsLoading(false);
                    setProgress(0);
                    alert("✅ Data Saved Successfully!");
                    
                    // Clear form
                    setFormData({ 
                        receiptNo: '', date: '', name: '', descSelect: '', 
                        descText: '', paymentMode: '', amount: '' 
                    });
                }, 500);

            } else {
                setIsLoading(false);
                setProgress(0);
                alert("❌ Error: " + result.message);
            }

        } catch (error) {
            clearInterval(progressInterval);
            setIsLoading(false);
            setProgress(0);
            console.error("Submission Error:", error);
            alert("❌ Server Connection Error");
        }
    };

    return (
      <div className="details-container">
        
        {/* --- 5. PROGRESS BAR UI OVERLAY (New) --- */}
        {isLoading && (
            <div className="loading-overlay">
                <div className="loading-box">
                    <h3>Processing...</h3>
                    <div className="progress-container">
                        <div 
                            className="progress-bar-fill" 
                            style={{ width: `${progress}%` }}
                        ></div>
                    </div>
                    <p>{progress}%</p>
                </div>
            </div>
        )}

        {/* --- SIGNOUT BUTTON --- */}
        <button className="logout-btn" onClick={handleManualLogout}>
          <FaSignOutAlt />
          <span>Sign Out</span>
        </button>

        {/* --- POPUP MODAL --- */}
        {showExitModal && (
          <div className="modal-overlay">
            <div className="modal-box">
              <h3>Warning</h3>
              <p>Do you want to Sign Out?</p>
              <div className="modal-actions">
                <button className="btn-confirm" onClick={handleYesLogout}>
                  Yes
                </button>
                <button className="btn-cancel" onClick={handleNoStay}>
                  No
                </button>
              </div>
            </div>
          </div>
        )}

        {/* --- BACKGROUND SHAPES --- */}
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>

        {/* --- TOP BRAND HEADER --- */}
        <div className="brand-header">
          <img src={topLogo} alt="Logo" className="brand-logo" />
          <div className="brand-text">
            <h2>गायत्री परिवार</h2>
            <h3>अलीराजपुर</h3>
          </div>
        </div>

        {/* --- PAGE HEADER --- */}
        <div className="details-header">
          <button className="back-btn" onClick={() => navigate("/home")}>
            <FaArrowLeft /> Back
          </button>
          <h2>
            <FaMoneyBillWave /> प्राप्त आय
          </h2>
        </div>

        {/* --- FORM SECTION --- */}
        <div className="form-content-wrapper">
          <div className="prapt-form-card">
            <form onSubmit={handleSubmit}>
              
              {/* 0. PAYMENT MODE */}
              <div className="prapt-form-group">
                <select
                  name="paymentMode"
                  value={formData.paymentMode}
                  onChange={handleChange}
                  className="prapt-input"
                >
                  <option value="">भुगतान का प्रकार (Mode)</option>
                  <option value="OFFLINE">OFFLINE</option>
                  <option value="ONLINE">ONLINE</option>
                </select>
              </div>

              {/* 1. Receipt No */}
              <div className="prapt-form-group">
                <input
                  type="text"
                  inputMode="numeric"
                  name="receiptNo"
                  placeholder="रसीद क्रमांक"
                  value={formData.receiptNo}
                  onChange={handleChange}
                  className="prapt-input"
                />
              </div>

              {/* 2. Date */}
              <div className="prapt-form-group">
                <input
                  type="text"
                  name="date"
                  placeholder="दिनांक"
                  value={formData.date}
                  onChange={handleChange}
                  onFocus={(e) => (e.target.type = "date")}
                  onBlur={(e) => (e.target.type = e.target.value ? "date" : "text")}
                  className="prapt-input date-style"
                />
              </div>

              {/* 3. Name */}
              <div className="prapt-form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="दानदाता का नाम"
                  value={formData.name}
                  onChange={handleChange}
                  className="prapt-input"
                />
              </div>

              {/* 4. Description Dropdown */}
              <div className="prapt-form-group">
                <select
                  name="descSelect"
                  value={formData.descSelect}
                  onChange={handleChange}
                  className="prapt-input"
                >
                  <option value="">विवरण का चयन करे</option>
                  <option value="गायत्री यज्ञ">गायत्री यज्ञ</option>
                  <option value="यज्ञ कुण्ड">यज्ञ कुण्ड</option>
                  <option value="अंशदान">अंशदान</option>
                  <option value="आओ गढे संस्कार वान पीढ़ी">आओ गढे संस्कार वान पीढ़ी</option>
                  <option value="दीक्षा एवं यज्ञोपवीत संस्कार">दीक्षा एवं यज्ञोपवीत संस्कार</option>
                  <option value="अन्य संस्कार से प्राप्त आय">अन्य संस्कार से प्राप्त आय</option>
                  <option value="नवरात्री पर्व">नवरात्री पर्व</option>
                  <option value="दान पेटी से प्राप्त आय">दान पेटी से प्राप्त आय</option>
                  <option value="वस्तु दान की बिक्री से आय">वस्तु दान की बिक्री से आय</option>
                  <option value="गौशाला हेतु दान">गौशाला हेतु दान</option>
                  <option value="साहित्य से बिक्री">साहित्य से बिक्री</option>
                  <option value="बैंक ब्याज से प्राप्त आय">बैंक ब्याज से प्राप्त आय</option>
                  <option value="अन्य स्रोत से आय">अन्य स्रोत से आय</option>
                </select>
              </div>

              {/* 5. Description Text */}
              <div className="prapt-form-group">
                <input
                  type="text"
                  name="descText"
                  placeholder="विवरण लिखे"
                  value={formData.descText}
                  onChange={handleChange}
                  className="prapt-input"
                />
              </div>

              {/* 6. Amount */}
              <div className="prapt-form-group">
                <input
                  type="number"
                  name="amount"
                  placeholder="जमा राशि"
                  value={formData.amount}
                  onChange={handleChange}
                  className="prapt-input"
                />
              </div>

              {/* SUBMIT BUTTON */}
              <button type="submit" className="prapt-submit-btn" disabled={isLoading}>
                {isLoading ? "Saving..." : "! ! जमा करे ! !"}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
};

export default Prapt_Aai;